var MENU_ITEM_HEIGHT = 24;
var ON_CLOSE_DELAY_MS = 100;
var VIEWPORT_MARGIN = 6;
var allowsIndent = 'hhiezw9';
var backdrop = 'hhiezwa';
var checkboxGroupItemCheckmark = 'hhiezwb';
var group = 'hhiezwc';
var groupInner = 'hhiezwd';
var item = 'hhiezwe _14wijgr9';
var itemIndent = 'hhiezwi';
var itemInner = 'hhiezwo';
var itemLead = 'hhiezwj hhiezwh';
var itemSelectIcon = 'hhiezwl';
var itemText = 'hhiezwk';
var itemTrail = 'hhiezwm hhiezwh';
var itemVariant = {'default':'hhiezwf',destructive:'hhiezwg'};
var popup = 'hhiezwp _14wijgr9';
var popupBg = 'hhiezwq';
var scroll = {grow:'hhiezwv hhiezwu',scroll:'hhiezww hhiezwu'};
var scrollArrow = 'hhiezwr';
var scrollContent = 'hhiezwt';
var separator = 'hhiezws';
var shortcut = 'hhiezwx hhiezwh';
var subText = 'hhiezwh';
var submenuTriggerTrail = 'hhiezwn';
var title = 'hhiezwz';

export { MENU_ITEM_HEIGHT, ON_CLOSE_DELAY_MS, VIEWPORT_MARGIN, allowsIndent, backdrop, checkboxGroupItemCheckmark, group, groupInner, item, itemIndent, itemInner, itemLead, itemSelectIcon, itemText, itemTrail, itemVariant, popup, popupBg, scroll, scrollArrow, scrollContent, separator, shortcut, subText, submenuTriggerTrail, title };
//# sourceMappingURL=menu-v2.css.js.map
